// removed by extract-text-webpack-plugin
module.exports = {"actions":"_3C9lt"};


//////////////////
// WEBPACK FOOTER
// ./app/components/category-description/category-description.scss
// module id = 1510
// module chunks = 0